import { api } from "../../../api/axiosInstance";
import type {
  EmailConfirmationRequest,
  FacebookSignupRequest,
  ForgotPasswordRequest,
  GoogleSignupRequest,
  LoginRequest,
  LogoutRequest,
  ResendEmailRequest,
  ResetPasswordRequest,
  SignUpRequest,
  SingpassSignUpVerificationRequest,
} from "../ts";

export const authAPI = {
  signup(request: SignUpRequest) {
    const { query_param = "", payload } = request;
    return api.post("/api/v1/auth/signup/" + query_param, payload);
  },
  signUpGoogle(request: GoogleSignupRequest) {
    const { query_param = "", payload } = request;
    return api.post("/api/v1/auth/oauth2/google/" + query_param, payload);
  },
  signUpFacebook(request: FacebookSignupRequest) {
    const { query_param = "", payload } = request;
    return api.post("/api/v1/auth/oauth2/facebook/" + query_param, payload);
  },
  resendEmail(request: ResendEmailRequest) {
    return api.post("/api/v1/auth/resend-email/", request);
  },
  emailConfirmation(request: EmailConfirmationRequest) {
    return api.patch("/api/v1/auth/email-confirmation/", request);
  },
  login(request: LoginRequest) {
    return api.post("/api/v1/auth/login/", request);
  },
  // loginOtp(request: LoginOtpRequest) {
  //   return api.post("/api/v1/auth/login/otp/", request);
  // },
  // loginConfirmationOtp(request: LoginOtpConfirmationRequest) {
  //   return api.post("/api/v1/auth/login-confirmation/", request);
  // },
  logout(request: LogoutRequest) {
    return api.post("/api/v1/auth/logout/", request);
  },
  forgotPass(request: ForgotPasswordRequest) {
    return api.post("/api/v1/auth/forgot-password/", request);
  },
  resetPassword(request: ResetPasswordRequest) {
    return api.post("/api/v1/auth/reset-password/", request);
  },
  singpassOAuthUrl(request: { type: string }) {
    return api.get("/api/v1/auth/oauth2/singpass/?type=" + request.type);
  },
  signUpSingpass(request: { code: string; type: string }) {
    return api.post("/api/v1/auth/oauth2/singpass/?type=" + request.type, {
      code: request.code,
    });
  },
  signUpVerificationSingpass(request: SingpassSignUpVerificationRequest) {
    const { temp_token : token, ...rest } = request;
    return api.post("/api/v1/auth/oauth2/singpass/verification/", {...rest, token}, {
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
  },
};
